import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/saint-events")({
  beforeLoad: () => {
    throw redirect({ to: "/saint-breakthrough-event" });
  },
});
